<template>
  <b-modal
    id="edit-leave-modal"
    modal-class="timesheet-modal"
    title="Edit Leave Entry"
    @hidden="$emit('hidden')"
  >
    <b-form-group label="Leave Type">
      <b-form-select v-model="form.leave_type" :options="leaveTypeOptions" />
    </b-form-group>
    <b-form-group label="Start Date">
      <b-form-datepicker
        v-model="form.start_date"
        locale="en-AU"
        today-button
        reset-button
        close-button
        show-decade-nav
      />
    </b-form-group>
    <b-form-group label="End Date">
      <b-form-datepicker
        v-model="form.end_date"
        locale="en-AU"
        today-button
        reset-button
        close-button
        show-decade-nav
      />
    </b-form-group>
    <b-form-group label="Include Weekends">
      <b-form-checkbox v-model="form.include_weekends" switch />
    </b-form-group>
    <b-form-group label="Hours per day">
      <b-form-input
        v-model.number="form.hours_per_day"
        type="number"
        min="0"
        max="24"
        step="0.5"
        placeholder="Company default"
      />
    </b-form-group>
    <b-form-group label="Note">
      <b-form-input v-model="form.note" />
    </b-form-group>

    <template #modal-footer>
      <b-button
        variant="outline-danger"
        class="mr-auto"
        @click="$emit('delete')"
      >
        Delete Entry
      </b-button>
      <b-button variant="secondary" @click="$bvModal.hide('edit-leave-modal')">
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="!canSubmit"
        @click="$emit('ok', $event)"
      >
        Save
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { LEAVE_TYPE_OPTIONS } from '@/utils/timesheetHelpers'

export default {
  name: 'TimesheetEditLeaveModal',
  props: {
    form: { type: Object, required: true },
    today: { type: String, default: '' },
  },
  computed: {
    // Editing an existing leave entry can't turn it back into a worked day —
    // exclude the null-value ("Worked") option that TimesheetAddEntryModal's
    // segmented control offers on create.
    leaveTypeOptions() {
      return LEAVE_TYPE_OPTIONS.filter((opt) => opt.value !== null)
    },
    canSubmit() {
      return !!(
        this.form.leave_type &&
        this.form.start_date &&
        this.form.end_date
      )
    },
  },
}
</script>
